import 'css-chunksrc/client/pages/planzoneMembersPage/resourcesMenu/groups/groupList/group/styles.scss';export default {
  "group": "_group_18txz_1",
  "main": "_main_18txz_10",
  "selected": "_selected_18txz_22",
  "name": "_name_18txz_22",
  "groupIcon": "_groupIcon_18txz_26",
  "menu": "_menu_18txz_42",
  "droppable": "_droppable_18txz_51"
};